import React, { useState } from 'react';
import { i18n } from 'next-i18next';
import appUtils from '../../../../utils/appUtils';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@lb-classroom/ui';
import classnames from 'classnames';
import { formatAddedDays } from '../../../../lib/date-utils';

interface Props {
  updateChosenDate: any;
  chosenDate: any;
  timezone: string;
}

const TutorFilterDatePicker: React.FC<Props> = (props: Props) => {
  const [show, setShow] = useState(false);
  const { updateChosenDate, timezone, chosenDate } = props;
  const language = i18n.language;
  const currentLocale = appUtils.getLocaleFromLang(language);

  const getDateSentence = () => {
    let format = 'dddd, MMM D';
    if (currentLocale === 'ja') {
      format = 'M月D日 (ddd)';
    } else if (currentLocale === 'tw') {
      format = 'M月D日, ddd';
    } else if (currentLocale === 'es') {
      format = 'ddd D MMM';
    } else if (currentLocale === 'pt') {
      format = 'ddd, D \\d\\e MMM';
    } else if (currentLocale === 'ru') {
      format = 'ddd, D.M';
    }
    const dateSentence = formatAddedDays(
      new Date(),
      Number(chosenDate),
      timezone,
      format,
      currentLocale,
    );
    return dateSentence;
  };

  const handleOpenChange = (flag: boolean) => {
    setShow(flag);
  };

  const onChoseDate = (e: React.MouseEvent, value: number) => {
    e.preventDefault();
    updateChosenDate(value);
    setShow(false);
  };

  let format = 'dddd, MMM D';
  if (currentLocale === 'ja') {
    format = 'M月D日 (ddd)';
  } else if (currentLocale === 'tw') {
    format = 'M月D日, ddd';
  } else if (currentLocale === 'es') {
    format = 'ddd D MMM';
  } else if (currentLocale === 'pt') {
    format = 'ddd, D \\d\\e MMM';
  } else if (currentLocale === 'ru') {
    format = 'ddd, D.M';
  }

  const wrapClass = classnames(
    'h-16 w-full flex justify-center items-center hover:bg-light-gray border-r border-l border-light-gray',
    {
      'bg-light-gray': show,
    },
  );

  return (
    <DropdownMenu open={show} onOpenChange={handleOpenChange}>
      <DropdownMenuTrigger asChild>
        <a className="cursor-pointer" onClick={(e) => e.preventDefault()}>
          <div className={wrapClass}>{getDateSentence()}</div>
        </a>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64">
        {[0, 1, 2, 3].map((i) => {
          const sentence = formatAddedDays(
            new Date(),
            i,
            timezone,
            format,
            currentLocale,
          );
          return (
            <DropdownMenuItem
              key={`date-select-${i}`}
              onClick={(e) => onChoseDate(e, i)}
            >
              {sentence}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default TutorFilterDatePicker;
